import { FilterCombinator, type FilterOptions } from './query.model';

// The backend only allows the first filter without a combinator; the rest are
// concatenated with AND. This normalizes any filter list to that contract.
export function normalizeFilterCombinators(filters: FilterOptions[]): FilterOptions[] {
  return filters.map((filter, index) => ({
    ...filter,
    combinator: index === 0 ? FilterCombinator.NONE : FilterCombinator.AND,
  }));
}
